import {TextEncoder} from "encoding";
import Bottleneck from "bottleneck";
import Device from "../device.js";


const TIMEOUT = 500;

class EZO_RGB extends Device {
  constructor(serialPort) {    
    super(serialPort);

    this.id = "EZO_RGB";
    this.status = "uninitialized";        
    this.serialPort = serialPort;

    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });     

    jfermi.RM_RGBSensor_setTargetLEDBrightness = this.setTargetLEDBrightness.bind(this);
  }
  async initialize() {
    try {            
      await this.serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });      
      this.status = "OK";
                  
      var result = await this.getTargetLEDBrightness();
      var [resp,targetLEDBrightness,powerSaving] = result.split(",");
      this.targetLEDBrightness = targetLEDBrightness;
      this.powerSaving = powerSaving;
      this.usbProductName = (await this.serialPort.getInfo()).usbProductName;
	  this.usbSerialNumber = (await this.serialPort.getInfo()).usbSerialNumber;    
      this.name = "rgbSensor";      
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {              
      var result = await this.command("R");
      var [red, green, blue, str, lux] = result.split(",");
      this.red = red;
      this.green = green;
      this.blue = blue;
      this.lux = lux;
      this.value = `${this.red}:${this.green}:${this.blue}`;

      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  }
  async getTargetLEDBrightness() {
    return await this.command(`L,?`);    
  }
  async setTargetLEDBrightness(request, value, powerSaving) {
    await this.command(`L,${value}${powerSaving?",T":""}`);    

    var result = await this.getTargetLEDBrightness();
    var [resp,targetLEDBrightness,powerSaving] = result.split(",");
    this.targetLEDBrightness = targetLEDBrightness;
    this.powerSaving = powerSaving;

    return true;
  }
  /* sending new command to the device while waiting for the response may cause concurrency problems           */
  /* so we wrapped the function and limited the maximum number of concurrent calls to 1 with bottlenck library */  
  async command(command) {    
    //console.log("command: "+command);
    return await this.limiter.schedule(() => this.command_wrapped_with_timeout(command));
  }  
  command_wrapped_with_timeout(command) {
    var promise = this.command_wrapped(command);

    var timeout = new Promise(function(resolve, reject) {
      setTimeout(function() {
        reject( new Error("timeout") );
      }, TIMEOUT);
    });

    return Promise.race([promise, timeout]);    
  } 
  async command_wrapped(command) {    
    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${command}\r`).buffer);
    writer.releaseLock();    
    const reader = this.serialPort.readable.getReader();

    var result = "";
    var response_code;
    while (true) {
      const { value, done } = await reader.read();      
      result += String.fromCharCode.apply(null, new Uint8Array(value));            
      //if (done || result.endsWith('*OK\r')) {
      if (done || result.match(/.*\*.*\r$/g)) {        
        response_code = /.*\*.*\r$/g.exec(result)[0];
        response_code = response_code.replace(/(\r\n|\n|\r)/gm, "");
        
        // |reader| has been canceled.       
        result = result.replace("*OK\r","");
        result = result.replace("\r","");
        result = result.toUpperCase();
        break;
      }        
    }

    reader.releaseLock();
    
    if (response_code != "*OK")
      throw new Error({
        "*ER": "unknown command",
        "*OV": "over volt (VCC>=5.5V)",
        "*UV": "under volt (VCC<=3.1V)",
        "*RS": "reset",
        "*RE": "boot up complete, ready",
        "*SL": "entering sleep mode",
        "*WA": "wake up",
        "*WARM": "warm up"
      }[response_code]);
      
    return result;      
  }
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,
      red: this.red,
      green: this.green,
      blue: this.blue,
      lux: this.lux,
      targetLEDBrightness: this.targetLEDBrightness,
      powerSaving: this.powerSaving
    });
  }
}

export default EZO_RGB;